import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';

/**
 * Application initializer that sets up authentication state on app startup.
 * Checks for existing tokens and refreshes them if necessary.
 */
export const authInitializer = () => {
  const authService = inject(AuthService);
  return authService.initializeAuth();
};
